import React from "react";
import { Autocomplete, Box, InputLabel, OutlinedInput } from "@mui/material";
import FormSection from "../../Forms/FormSection/form-section";
import { DbUserGroupInfos } from "../../../Core/Api/Types/db-user-group-infos";
import { AclWorkflowAccessLevel } from "../../../Core/Api/Types/acl-workflow-access-level";
import { AclAssetAccessLevel } from "../../../Core/Api/Types/acl-asset-access-level";
import { DbUserGroupRoleInfos } from "../../../Core/Api/Types/db-user-group-role-infos";
import { useTranslation } from "react-i18next";

interface ConfigContextLevelSettingsProps {
  groupInfos: DbUserGroupInfos | DbUserGroupRoleInfos;
  onSetGroupInfos?: (value: any, context: "aclWorkflowAccessLevel" | "AclAssetAccessLevel") => void;
}

const ConfigContextLevelSettings: React.FC<ConfigContextLevelSettingsProps> = (props) => {
  const { t } = useTranslation();
  const { groupInfos, onSetGroupInfos } = props;

  return (
    <FormSection title={t("form:section.title.contextsLevelSettings")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("field:label.workflowAccessLevel")}</InputLabel>
      <Autocomplete
        value={groupInfos.aclWorkflowAccessLevel}
        id={"aclWorkflowAccessLevel"}
        sx={{ width: "100%" }}
        onChange={(e, value) => {
          onSetGroupInfos && onSetGroupInfos(value, "aclWorkflowAccessLevel");
        }}
        renderInput={(params) => (
          <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%", mb: 2 }} />
        )}
        options={Object.keys(AclWorkflowAccessLevel)}
        renderOption={(props, option) => (
          <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
            {option}
          </Box>
        )}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.assetAccessLevel")}</InputLabel>
      <Autocomplete
        value={groupInfos.aclAssetAccessLevel}
        id={"aclAssetAccessLevel"}
        sx={{ width: "100%" }}
        onChange={(e, value) => {
          onSetGroupInfos && onSetGroupInfos(value, "AclAssetAccessLevel");
        }}
        renderInput={(params) => (
          <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
        )}
        options={Object.keys(AclAssetAccessLevel)}
        renderOption={(props, option) => (
          <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
            {option}
          </Box>
        )}
      />
    </FormSection>
  );
};

export default ConfigContextLevelSettings;
